import {
  EUAndUKCountries as EUAndUKCountriesBase,
  EUCountries as EUCountriesBase,
  TIER_ONE_COUNTRIES as TIER_ONE_COUNTRIES_BASE,
  useUserLocation as useUserLocationBase,
} from '@repo/hooks-use-user-location'

export const EUAndUKCountries = EUAndUKCountriesBase
export const EUCountries = EUCountriesBase
export const TIER_ONE_COUNTRIES = TIER_ONE_COUNTRIES_BASE
export const useUserLocation = useUserLocationBase
